
import { ResizeEvent }     from './resize.event';
import { EventType }       from './event.type';
import { empty }           from "@/util/util";

/**
 *
 * @class FramebufferResizeEvent
 *
 * when the internal framebuffer size changes
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class FramebufferResizeEvent extends ResizeEvent {

  /** framebuffer scale */
  private _fbs: number       = 0;

  /** standard constructor */
  constructor(krpano : any, w: number, h: number, scale: number,  frameBufferScale: number) {

    super(krpano, w, h, scale, EventType.FRAMEBUFFER_RESIZE);

    this._fbs = frameBufferScale;
  }

  /** scaling factor */
  frameBufferScale(): number {

    return this._fbs;
  }

}
